"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _DefaultString = require("../../helpers/DefaultString");

var _auth = require("../../redux/modules/auth");

var _reactIntl = require("react-intl");

var _MaintenanceBanner = require("./MaintenanceBanner.scss");

var _MaintenanceBanner2 = _interopRequireDefault(_MaintenanceBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MaintenanceIcon = require("../../../res/images/icon/maintenance_icon.svg");

var MaintenanceBanner = function (_Component) {
  (0, _inherits3.default)(MaintenanceBanner, _Component);

  function MaintenanceBanner() {
    (0, _classCallCheck3.default)(this, MaintenanceBanner);
    return (0, _possibleConstructorReturn3.default)(this, (MaintenanceBanner.__proto__ || (0, _getPrototypeOf2.default)(MaintenanceBanner)).apply(this, arguments));
  }

  (0, _createClass3.default)(MaintenanceBanner, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: _MaintenanceBanner2.default.maintenanceBanner },
        _react2.default.createElement(
          "div",
          { className: _MaintenanceBanner2.default.maintenanceIcon },
          _react2.default.createElement("img", { src: MaintenanceIcon, className: _MaintenanceBanner2.default.filter })
        ),
        _react2.default.createElement(
          "div",
          { className: _MaintenanceBanner2.default.maintenanceText },
          _react2.default.createElement(
            "div",
            { className: _MaintenanceBanner2.default.maintenanceTitle },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.MaintenanceTitle)
          ),
          _react2.default.createElement(
            "div",
            { className: _MaintenanceBanner2.default.maintenanceDesc },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.MaintenanceDescription)
          )
        )
      );
    }
  }]);
  return MaintenanceBanner;
}(_react.Component);

exports.default = MaintenanceBanner;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/MaintenanceBanner/MaintenanceBanner.js
// module id = 1960
// module chunks = 0